// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3vMxm","col":"styles_col__1Hqx1"};